import { Component, EventEmitter, Output } from '@angular/core';
import { FinancialSummaryService } from '../financial-summary/financial-summary.service';

@Component({
  selector: 'app-table-financial-summary',
  templateUrl: './table-financial-summary.component.html',
  styleUrls: ['./table-financial-summary.component.scss'],
})
export class TableFinancialSummaryComponent {
  public filterType = 'accountId';
  public searchValue = '';
  public startDateIso?: string;
  public endDateIso?: string;

  public page = 1;
  public pageSize = 20;
  public total = 0;

  public rows: any[] = [];

  @Output() rowsLoaded = new EventEmitter<any[]>();

  constructor(private financialSummaryService: FinancialSummaryService) {}

  load(): void {
    const startDate = this.startDateIso ?? '';
    const endDate = this.endDateIso ?? '';

    if (!startDate || !endDate) {
      this.rows = [];
      this.total = 0;
      this.rowsLoaded.emit(this.rows);
      return;
    }

    const params: any = {
      startDate,
      endDate,
      page: this.page,
      pageSize: this.pageSize,
    };

    const value = (this.searchValue || '').trim();
    if (value) {
      if (this.filterType === 'accountId') params.accountId = value;
      if (this.filterType === 'document') params.document = value;
      if (this.filterType === 'userId') params.userId = value;
    }

    this.financialSummaryService.getSummaryFinancial(params).subscribe({
      next: (resp: any) => {
        const list =
          resp?.summaryFinancial ??
          resp?.summaryFinancials ??
          resp?.items ??
          resp?.data ??
          resp?.result ??
          (Array.isArray(resp) ? resp : []);

        this.rows = Array.isArray(list) ? list : [];
        this.total = resp?.total ?? resp?.totalCount ?? resp?.count ?? this.rows.length;
        this.rowsLoaded.emit(this.rows);
      },
      error: () => {
        this.rows = [];
        this.total = 0;
        this.rowsLoaded.emit(this.rows);
      },
    });
  }

  pageChange(): void {
    this.load();
  }
}